// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconStar.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconStar = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M0.421139 7.21977L3.54026 9.58671C3.89665 9.85703 4.04597 10.3362 3.91011 10.7738L2.71801 14.6046C2.41387 15.5832 3.48606 16.3971 4.2835 15.7924L7.40262 13.4251C7.75901 13.1544 8.24117 13.1544 8.59756 13.4251L11.7167 15.7924C12.5138 16.3971 13.5863 15.5832 13.2822 14.6046L12.0906 10.7738C11.954 10.3362 12.1034 9.85703 12.4601 9.58671L15.5789 7.21977C16.3756 6.61475 15.9666 5.29797 14.9814 5.29797H11.1259C10.6856 5.29797 10.2943 5.00157 10.1586 4.564L8.96741 0.734479C8.66292 -0.244826 7.33761 -0.244826 7.03277 0.734479L5.84085 4.56419C5.70517 5.00176 5.3153 5.29816 4.87424 5.29816H1.01861C0.0333971 5.29816 -0.375601 6.61494 0.421139 7.21977Z" />
  </BaseIcon>
);

export default IconStar;
